module.exports = __webpack_public_path__ + "img/solar-side-up.cb54694c.jpg";